module.exports = __webpack_public_path__ + "img/fresh_vs_frozen.f7a01c6e.jpg";